if (typeof ShopifyAPI === "undefined") {
  ShopifyAPI = {};
}

ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  var params = {
    type: "POST",
    url: "/cart/add.js",
    data: jQuery(form).serialize(),
    dataType: "json",
    success: function (line_item) {
      if (typeof callback === "function") {
        callback(line_item, form);
      } else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if (typeof errorCallback === "function") {
        errorCallback(XMLHttpRequest, textStatus);
      }
    },
  };
  jQuery.ajax(params);
};

ShopifyAPI.getCart = function (callback) {
  jQuery.getJSON("/cart.js", function (cart, textStatus) {
    if (typeof callback === "function") {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

ShopifyAPI.changeItem = function (line, quantity, callback) {
  var params = {
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + quantity + "&line=" + line,
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
  };
  jQuery.ajax(params);
};

var init, loadCart;

// Private plugin variables
var $formContainer,
  $addToCart,
  $cartCountSelector,
  $cartCostSelector,
  $cartContainer,
  $drawerContainer,
  $body,
  $buildCart;

// Private functions
var updateCountPrice,
  formOverride,
  itemAddedCallback,
  itemErrorCallback,
  adjustCartCallback,
  cartUpdateCallback,
  cartUpdateCallbackInitial,
  validateQty;

init = function () {
  // Default settings
  settings = {
    addToCartSelector: 'input[type="submit"]',
    cartCountSelector: "#drawer__item-count",
    cartContainer: "#cart__drawer_items",
  };

  $formContainer = $("form.shopify-product-form");
  $addToCart = $formContainer.find(settings.addToCartSelector);
  $cartCountSelector = $(settings.cartCountSelector);
  $cartContainer = $(settings.cartContainer);

  $body = $("body");

  checkUpsell();
};
formOverride = function () {
  $formContainer.on("submit", function (evt) {
    evt.preventDefault();

    // Add class to be styled if desired
    $addToCart.removeClass("is-added").addClass("is-adding");

    // Remove any previous quantity errors
    $(".qty-error").remove();

    ShopifyAPI.addItemFromForm(
      evt.target,
      itemAddedCallback,
      itemErrorCallback.bind(this)
    );
  });
};

itemAddedCallback = function (product) {
  $addToCart.removeClass("is-adding").addClass("is-added");

  ShopifyAPI.getCart(cartUpdateCallback);
};

itemErrorCallback = function (XMLHttpRequest, textStatus) {
  var $form = $(this);
  var $button = $form.find(settings.addToCartSelector);
  var data = eval("(" + XMLHttpRequest.responseText + ")");

  $button.removeClass("is-adding is-added");

  if (!!data.message) {
    if (data.status == 422) {
      $form.after(
        '<div class="errors qty-error">' + data.description + "</div>"
      );
    }
  }
};

cartUpdateCallback = function (cart) {
  // Update quantity and price
  updateCountPrice(cart);
  buildCart(cart);
  cartCallback(cart);
};

cartUpdateCallbackInitial = function (cart) {
  // Update quantity and price
  updateCountPrice(cart);
  buildCart(cart);
};
updateCountPrice = function (cart) {
  if(cart.item_count > 0)
  {
    $('.cart-item__count').text(cart.item_count);
  }
  else
  {
    $('.cart-item__count').text("");
  }
  if ($cartCountSelector) {
    $cartCountSelector
      .html(cart.item_count + " items")
      .removeClass("hidden-count");

    if (cart.item_count === 0) {
      $cartCountSelector.addClass("hidden-count");
    }
  }
  if ($cartCostSelector) {
    $cartCostSelector.html(cart.total_price, Shopify.money_format);
  }
};

buildCart = function (cart) {
  var line_item = "";
  $cartContainer.empty();
  if (cart.items.length > 0) {
    cart.items.forEach(function (product, index) {
      console.log('prod', product)
      line_item += `
            <div class="line-item" data-line="${index + 1}" data-product="${product.product_id}">
              <div class="line-item__boday">
                <div class="line-item__image">
                  <img src="${product.featured_image.url}" alt="${
        product.featured_image.alt
      }">
                </div>
                <div class="line-item__header line-item__info">
                    <div class="line-item__title">
                      <p>${product.product_title}</p>
                    </div>
                    <div class="line-item__color">
                      <p>${product.variant_options[1] ? product.variant_options[1] : ''}</p>
                    </div>
                    <div class="line-item__size">
                      <p>${product.variant_options[0] ? product.variant_options[0] : ''}</p>
                    </div>
                    <div class="line-item__length">
                      <p>${product.variant_options[2] ? product.variant_options[2] : ''}</p>
                    </div>
                    <div class="line-item__qty">
                      <div class="qtybox">
                        <button type="button" data-line="${
                          index + 1
                        }" class="btnqty qtyminus icon icon-minus">-</button>
                        <input type="text" id="quantity" name="quantity" value="${
                          product.quantity
                        }" min="1" class="quantity-selector quantity-input" readonly="">
                        <button type="button" data-line="${
                          index + 1
                        }" class="btnqty qtyplus icon icon-plus">+</button>
                      </div>
                    </div>
                    <button data-line="${
                      index + 1
                    }" class="line-item__remove-btn">
                      Remove
                    </button>
                    </div>
              </div>
            </div>
            `;
    });
    $cartContainer.append(line_item);
  } else {
    const cartDrawerItems = document.getElementById("cart__drawer_items");

    if (!!(cartDrawerItems)) {
      cartDrawerItems.innerHTML = '<p class="empty-cart">Cart is empty</p>';
    }

    if(document.getElementById("cart__checkout_btn")){
      document.getElementById("cart__checkout_btn").setAttribute("disabled", "disabled");
      document.getElementById("cart__checkout_btn").style.pointerEvents = "none";
    }
  }

  let shopCurrency = $('#currentCurrency').text().replace('0.00', '\{\{ amount \}\}')
  // $("#cart__total_price").html($('#currentCurrency').text().replace('0.00', '') + (cart.total_price / 100).toFixed(2));
  $("#cart__total_price").html(theme.Currency.formatMoney(cart.total_price, theme.moneyFormat));

  $('#cart__drawer_items').find('.line-item .line-item__length').each(function () {
    let item_length = $(this).find('p').text();
    if(item_length == 'undefined') {
      $(this).hide();
    }
  })

  checkUpsell();
};

let ajaxUpsell;
function checkUpsell() {
  $('.c-upsell__item').each(function() {
    let id = $(this).attr('data-product');
    if($(`.line-item[data-product="${id}"]`).length) {
      $(this).addClass('hide')
      $(this).closest('.swiper-slide').addClass('hide')
    } else {
      $(this).removeClass('hide');
      $(this).closest('.swiper-slide').removeClass('hide');
    }
  })
  if(!$('.c-upsell__item:not(.hide)').length) {
    $('.c-upsell').hide();
  } else {
    $('.c-upsell').show();
  }
  if(ajaxUpsell) {
    ajaxUpsell.destroy();
  }
  ajaxUpsell = new Swiper(document.querySelector('.drawer__wrapper .c-upsell__list'), {
    slidesPerView: 1,
    // autoHeight: true,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
  });
}

cartCallback = function (cart) {
  $("[data-drawer-target]").addClass("is-active").addClass("is-visible");
  $("body").trigger("ajaxCart.afterCartLoad", cart);
};

loadCart = function () {
  ShopifyAPI.getCart(cartUpdateCallbackInitial);
  checkUpsell();
};

function updateQuantity(line, qty) {
  isUpdating = true;

  // Add activity classes when changing cart quantities
  var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass(
    "is-loading"
  );

  if (qty === 0) {
    $row.parent().addClass("is-removed");
  }

  // Slight delay to make sure removed animation is done
  setTimeout(function () {
    ShopifyAPI.changeItem(line, qty, adjustCartCallback);
  }, 250);
}

adjustCartCallback = function (cart) {
  isUpdating = false;

  // Update quantity and price
  updateCountPrice(cart);

  // Reprint cart on short timeout so you don't see the content being removed
  setTimeout(function () {
    ShopifyAPI.getCart(buildCart);
  }, 150);
};

$("body").on("click", ".line-item__qty .btnqty", function () {
  var $el = $(this),
    line = $el.data("line"),
    $qtySelector = $el.siblings(".line-item__qty .quantity-input"),
    qty = parseInt($qtySelector.val().replace(/\D/g, ""));

  var qty = validateQty(qty);

  // Add or subtract from the current quantity
  if ($el.hasClass("qtyplus")) {
    qty += 1;
  } else {
    qty -= 1;
    if (qty <= 0) qty = 0;
  }

  // If it has a data-line, update the cart.
  // Otherwise, just update the input's number
  if (line) {
    updateQuantity(line, qty);
  } else {
    $qtySelector.val(qty);
  }
});

$("body").on("click", ".line-item__header .line-item__remove-btn", function () {
  var $el = $(this),
    line = $el.data("line");
  updateQuantity(line, 0);
});

validateQty = function (qty) {
  if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
    // We have a valid number!
  } else {
    // Not a number. Default to 1.
    qty = 1;
  }
  return qty;
};

init();
loadCart();
formOverride();


